<template>
  <div
    class="ab_a-actions_action"
    :class="[
      {
        opacity_0: !open
          ? !(action.is_selected || (usePreselected && action.is_preselected))
          : false,
      },
      action.is_selected || (usePreselected && action.is_preselected)
        ? `a-action_selected`
        : 'clr-grey',
      open ? 'gw_btn_hover_back' : '',
    ]"
    style="--btn-back-clr-back: var(--ha-action-hovered-clr-back); --btn-back-z-index: -1"
    :style="`${
      action.is_selected || (usePreselected && action.is_preselected)
        ? `--ha-aa-color:var(${getResColor(action)});`
        : ''
    }`"
  >
    <HaAction
      :showBetsIn="showBetsIn"
      :action="action"
      :hasBBPot="hasBBPot"
    >
    </HaAction>

    <div
      v-if="hasMetrics && !!action.frequency"
      class="ab_a-action-metrics_metric ab_a-action-metrics_fre"
      v-html="
        `<span>${numFixedUnit(
          action.frequency * 100,
          'strategy',
        )}<span style='font-size:0.7rem'>%</span>
        </span>`
      "
    />
    <!-- bettingInfo.evIcmConverters >> only in trainer - in hints mode -->

    <div
      v-if="hasMetrics && !isNa && hasEv"
      class="ab_a-action-metrics_metric ab_a-action-metrics_ev"
      v-html="
        getEvHtml({
          ...bettingInfo,
          ignoreIcmEvIntercept: true,
          ev: action.ev,
          ...(bettingInfo.evIcmConverters && bettingInfo.evIcmConverters[0]
            ? {
                player: 'hero',
                unit: `<span class='ev-as-pot_percent'>EV</span>`,
              }
            : {
                simple: true,
                percentUnit: `%`,
                unit: `<span class='ev-as-pot_percent'>EV</span>`,
              }),
        })
      "
    />
    <div
      v-else
      class="ab_a-action-metrics_metric ab_a-action-metrics_na"
    >
      N/A
    </div>
  </div>
</template>

<script>
import HaAction from '@/components/AnalyzeStreetBlocks/HaAction'
import format_mix from '@/mixins/format_mix'

export default {
  name: 'HaActionMetrics',
  components: {
    HaAction,
  },
  mixins: [format_mix],
  props: {
    hasBBPot: Boolean,
    sizeMode: { default: () => 'L' },
    action: Object,
    open: Boolean,
    showBetsIn: String,
    bettingInfo: Object,
    usePreselected: { type: Boolean, default: true },
    hasMetrics: { type: Boolean, default: true },
    isNa: Boolean,
    hasEv: { type: Boolean, default: true },
  },
  methods: {
    getResColor(action) {
      return action?.correctness_group?.color
    },
  },
}
</script>

<style lang="scss" scoped>
.ab {
  &_a-actions {
    &_action {
      color: var(--ha-aa-color);
      min-height: var(--ha-am-height);
      height: var(--ha-am-height);
      display: var(--ha-am-row-display);
      font-size: var(--ha-am-size);
      font-weight: var(--ha-am-weight);

      cursor: default !important;
      width: 100%;
      position: relative;
      font-weight: 400;
      flex-shrink: 0;
      transition: 0.2s;

      &.a-action_selected {
        background: var(--ha-background);

        z-index: 4;
        .ab_a-action {
          color: inherit !important;
          z-index: 3;
          &_real-bet {
            z-index: 4;
          }
        }
      }
    }
  }
  &_a-action-metrics {
    position: relative;
    z-index: 3;
    &_metric {
      text-align: right;
      justify-content: flex-end;
      flex: 1;
      position: relative;
      padding: var(--ha-am-metric-padding);
      display: var(--ha-am-cell-display);
      font-size: var(--ha-am-cell-size);
      font-weight: var(--ha-am-cell-weight);
    }
    &_ev {
      min-width: var(--ha-am-ev-width);
    }
  }
}
</style>
